import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import Accordion from 'Common/Accordion/Accordion';
import IconCard from 'Common/Cards/IconCard';
import EmailDialog from '../containers/EmailDialog';
import DataTable from 'Components/DataTable/DataTable';
import BackButton from 'Containers/BackButton/BackButton';
import { updateFilter, load, readEmailThread, readEmail } from 'Actions/email';
import { DataTableMetadataType, QueryFilterType } from 'Types';
import {
    DATA_TABLE_COLUMN_TYPE_DATE,
    DATA_TABLE_COLUMN_TYPE_LINK,
    DATE_TIME_FORMAT, ROLE_EDITOR, TYPE_EXTERNAL,
} from 'Constants';
import moment from 'moment';
import { aclDecorator } from 'Decorators';

@connect(store => ({
    emails: store.emailsList.data,
    filter: store.emailsList.filter,
    metadata: store.emailsList.metadata,
    userId: store.auth.user.id,
}), dispatch => ({
    updateFilter: filter => dispatch(updateFilter(filter)),
    load: (submissionId, filter) => dispatch(load(submissionId, filter)),
    readEmailThread: id => dispatch(readEmailThread(id)),
    readEmail: id => dispatch(readEmail(id)),
}))
@aclDecorator()
export default class Emails extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        emails: PropTypes.array,
        submissionId: PropTypes.any.isRequired,
        filter: QueryFilterType.isRequired,
        metadata: DataTableMetadataType,
        updateFilter: PropTypes.func.isRequired,
        load: PropTypes.func.isRequired,
        readEmailThread: PropTypes.func.isRequired,
        readEmail: PropTypes.func.isRequired,
        userId: PropTypes.number.isRequired,
        submissionData: PropTypes.object.isRequired,
        is: PropTypes.func.isRequired
    };

    state = {
        activeEmail: null
    };

    /**
     * @type {Object}
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    componentDidMount() {
        const { updateFilter } = this.props;
        updateFilter({where: {}});
    }

    handleOpenEmailsThread = (item) => {
        //const { readEmailThread } = this.props;
        this.setState({activeEmail: item});
        /*if (item.thread && item.thread.is_new) {
            readEmailThread(item.thread_id);
        }*/
    };

    renderHTML = (rawHTML: string) => React.createElement('div', { dangerouslySetInnerHTML: { __html: rawHTML } });

    stripTags = (text) => text.replace(/<\/?[^>]+(>|$)/g, '');

    getColumns = () => {
        return [
            {
                key: 'from',
                col: { width: '20%' },
                handler: (item) => {
                    return (<div className='emails-table-from-wrapper'>
                        { item.from }
                    </div>);
                },
            },
            {
                key: 'subject',
                col: { width: '35%' },
                type: DATA_TABLE_COLUMN_TYPE_LINK,
                link: {
                    to: '#',
                    onClick: this.handleOpenEmailsThread
                },
            },
            {
                key: 'body',
                col: { width: '40%' },
                handler: (item) => {
                    return (<div className='emails-table-body-text' style={{textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap'}}>
                        { this.stripTags(item.body) }
                    </div>);
                },
            },
            {
                key: 'created_at',
                type: DATA_TABLE_COLUMN_TYPE_DATE,
                col: { width: '5%' },
            },
        ];
    };

    loadEmails = (filter) => {
        const { submissionId, load } = this.props;
        load(submissionId, filter);
    };

    handleExpand = (id) => {
        const { readEmail, emails } = this.props;
        const email = emails.find(email => email.id === id);
        if (email && email.is_new) {
            readEmail(id).then(() => this.loadEmails({where: {}}));
        }
    };

    getHead = () => {
        const { submissionId, submissionData, is } = this.props;
        if (!submissionId) return null;

        return (
            <div>
                <BackButton to='/' title='button.to.submissions' />
                <div className='data-table-filters-wrap-block' style={{marginBottom: '0'}}>
                    <div className='data-table-title-block emails-tab-title'>
                        <FormattedMessage id={'title.emails'} />
                    </div>
                    {!is(ROLE_EDITOR) && <EmailDialog
                        submissionId={submissionId}
                        skipBtn={false}
                        isInitValues={true}
                        initUsers={[submissionData.user_id]}
                        allowedUsers={(
                            submissionData.reviewers ?
                                submissionData.reviewers.filter(reviewer => reviewer.type !== TYPE_EXTERNAL).map(reviewer => reviewer.user_id)
                                : []
                        ).concat([ submissionData.user_id ])}
                    />}
                </div>
            </div>
        );
    };

    getThread() {
        const { activeEmail } = this.state;
        const { emails, submissionId, userId } = this.props;
        let active = 0;

        return (
            <IconCard
                title={activeEmail.subject}
                backButton={
                    {
                        to: '#',
                        title: 'button.to.emails',
                        onClick: () => this.setState({activeEmail: null})
                    }
                }
                content={
                    <div className='emails-thread-accordion-wrapper'>
                        <Accordion
                            classes={{expansionPanelSummaryExpaned: 'expaned-email-thread'}}
                            collapses={
                                emails
                                    .filter((email) => email.thread_id === activeEmail.thread_id)
                                    .map((email, key) => {
                                        active = email.id === activeEmail.id ? key : active;
                                        const emailDate = email.received_at ? email.received_at : email.created_at;
                                        return {
                                            title:
                                                <div className={'accordion-title-wrapper' + (email.is_new ? ' email_new_wrapper' : '')}>
                                                    <div className='span-from'>From:</div>
                                                    <div className='span-email-from'>
                                                        { email.from }
                                                    </div>
                                                    <div className='span-email-text'>
                                                        { this.stripTags(email.body) }
                                                    </div>
                                                    <div className='span-email-created pull-right'>
                                                        { moment(emailDate).format(DATE_TIME_FORMAT) }
                                                    </div>
                                                </div>,
                                            content: (<div className='accordion-body-wrapper email-thread-wrapper'>
                                                <div className='email-in-thread-content-wrapper'>
                                                    { this.renderHTML(email.body.replace(/\n/g, '<br />')) }
                                                </div>
                                                <div className='email-body-wrapper'>
                                                    { email.user_id !== userId && <EmailDialog
                                                        submissionId={submissionId}
                                                        openBtnColor='success'
                                                        openBtnText={ this.context.intl.formatMessage({ id: 'button.submissions.reply_email' }) }
                                                        subject={email.subject}
                                                        to={email.from}
                                                        parentId={email.id}
                                                    /> }
                                                </div>
                                            </div>),
                                            id: email.id,
                                        };
                                    })
                            }
                            active={ active }
                            handleExpand={ this.handleExpand }
                        />
                    </div>
                }
            />
        );
    }

    getTable() {
        const { emails, filter, metadata, updateFilter } = this.props;

        return (
            <DataTable
                columns={this.getColumns()}
                metadata={metadata}
                data={
                    emails
                        .filter((email) => !email.parent_id)
                        .map((email) => {return {
                            ...email,
                            rawClassName: email.thread && email.thread.is_new ? 'raw-new' : ''
                        };})
                }
                filter={filter}
                load={this.loadEmails}
                updateFilter={updateFilter}
                icon={false}
                head={this.getHead()}
                hideTitlesRow
                tableClass='emails-submission-table'
            />
        );
    }

    render() {
        const { activeEmail } = this.state;

        return (
            <div className={'wrapEmailsList'}>
                { activeEmail && this.getThread() }
                { !activeEmail && this.getTable() }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/SubmissionManagement/components/Emails.jsx